// Mapping Sets
export const GET_MAPPING_SETS_REQUEST = 'GET_MAPPING_SETS_REQUEST';
export const GET_MAPPING_SETS_SUCCESS = 'GET_MAPPING_SETS_SUCCESS';
export const GET_MAPPING_SETS_ERROR = 'GET_MAPPING_SETS_ERROR';

export const GET_MAPPING_SETS_BY_VENDOR_REQUEST = 'GET_MAPPING_SETS_BY_VENDOR_REQUEST';
export const GET_MAPPING_SETS_BY_VENDOR_SUCCESS = 'GET_MAPPING_SETS_BY_VENDOR_SUCCESS';
export const GET_MAPPING_SETS_BY_VENDOR_ERROR = 'GET_MAPPING_SETS_BY_VENDOR_ERROR';

export const GET_MAPPING_SET_REQUEST = 'GET_MAPPING_SET_REQUEST';
export const GET_MAPPING_SET_SUCCESS = 'GET_MAPPING_SET_SUCCESS';
export const GET_MAPPING_SET_ERROR = 'GET_MAPPING_SET_ERROR';

export const CREATE_MAPPING_SET_REQUEST = 'CREATE_MAPPING_SET_REQUEST';
export const CREATE_MAPPING_SET_SUCCESS = 'CREATE_MAPPING_SET_SUCCESS';
export const CREATE_MAPPING_SET_ERROR = 'CREATE_MAPPING_SET_ERROR';

export const UPDATE_MAPPING_SET_REQUEST = 'UPDATE_MAPPING_SET_REQUEST';
export const UPDATE_MAPPING_SET_SUCCESS = 'UPDATE_MAPPING_SET_SUCCESS';
export const UPDATE_MAPPING_SET_ERROR = 'UPDATE_MAPPING_SET_ERROR';

export const DELETE_MAPPING_SET_REQUEST = 'DELETE_MAPPING_SET_REQUEST';
export const DELETE_MAPPING_SET_SUCCESS = 'DELETE_MAPPING_SET_SUCCESS';
export const DELETE_MAPPING_SET_ERROR = 'DELETE_MAPPING_SET_ERROR';

export const MAPPING_SETS_SAVE_ALL_REQUEST = 'MAPPING_SETS_SAVE_ALL_REQUEST';
export const MAPPING_SETS_SAVE_ALL_SUCCESS = 'MAPPING_SETS_SAVE_ALL_SUCCESS';
export const MAPPING_SETS_SAVE_ALL_ERROR = 'MAPPING_SETS_SAVE_ALL_ERROR';

// Mapping Rules
export const GET_MAPPING_SET_RULES_REQUEST = 'GET_MAPPING_SET_RULES_REQUEST';
export const GET_MAPPING_SET_RULES_SUCCESS = 'GET_MAPPING_SET_RULES_SUCCESS';
export const GET_MAPPING_SET_RULES_ERROR = 'GET_MAPPING_SET_RULES_ERROR';

export const CREATE_MAPPING_RULE_REQUEST = 'CREATE_MAPPING_RULE_REQUEST';
export const CREATE_MAPPING_RULE_SUCCESS = 'CREATE_MAPPING_RULE_SUCCESS';
export const CREATE_MAPPING_RULE_ERROR = 'CREATE_MAPPING_RULE_ERROR';

export const UPDATE_MAPPING_RULE_REQUEST = 'UPDATE_MAPPING_RULE_REQUEST';
export const UPDATE_MAPPING_RULE_SUCCESS = 'UPDATE_MAPPING_RULE_SUCCESS';
export const UPDATE_MAPPING_RULE_ERROR = 'UPDATE_MAPPING_RULE_ERROR';

export const DELETE_MAPPING_RULE_REQUEST = 'DELETE_MAPPING_RULE_REQUEST';
export const DELETE_MAPPING_RULE_SUCCESS = 'DELETE_MAPPING_RULE_SUCCESS';
export const DELETE_MAPPING_RULE_ERROR = 'DELETE_MAPPING_RULE_ERROR';

// Value Transforms
export const GET_VALUE_TRANSFORMS_REQUEST = 'GET_VALUE_TRANSFORMS_REQUEST';
export const GET_VALUE_TRANSFORMS_SUCCESS = 'GET_VALUE_TRANSFORMS_SUCCESS';
export const GET_VALUE_TRANSFORMS_ERROR = 'GET_VALUE_TRANSFORMS_ERROR';

export const CREATE_VALUE_TRANSFORM_REQUEST = 'CREATE_VALUE_TRANSFORM_REQUEST';
export const CREATE_VALUE_TRANSFORM_SUCCESS = 'CREATE_VALUE_TRANSFORM_SUCCESS';
export const CREATE_VALUE_TRANSFORM_ERROR = 'CREATE_VALUE_TRANSFORM_ERROR';

export const UPDATE_VALUE_TRANSFORM_REQUEST = 'UPDATE_VALUE_TRANSFORM_REQUEST';
export const UPDATE_VALUE_TRANSFORM_SUCCESS = 'UPDATE_VALUE_TRANSFORM_SUCCESS';
export const UPDATE_VALUE_TRANSFORM_ERROR = 'UPDATE_VALUE_TRANSFORM_ERROR';

export const DELETE_VALUE_TRANSFORM_REQUEST = 'DELETE_VALUE_TRANSFORM_REQUEST';
export const DELETE_VALUE_TRANSFORM_SUCCESS = 'DELETE_VALUE_TRANSFORM_SUCCESS';
export const DELETE_VALUE_TRANSFORM_ERROR = 'DELETE_VALUE_TRANSFORM_ERROR';

// Vendor
export const GET_VENDORS_REQUEST = 'GET_VENDORS_REQUEST';
export const GET_VENDORS_SUCCESS = 'GET_VENDORS_SUCCESS';
export const GET_VENDORS_ERROR = 'GET_VENDORS_ERROR';

export const GET_VENDOR_REQUEST = 'GET_VENDOR_REQUEST';
export const GET_VENDOR_SUCCESS = 'GET_VENDOR_SUCCESS';
export const GET_VENDOR_ERROR = 'GET_VENDOR_ERROR';

export const CREATE_VENDOR_REQUEST = 'CREATE_VENDOR_REQUEST';
export const CREATE_VENDOR_SUCCESS = 'CREATE_VENDOR_SUCCESS';
export const CREATE_VENDOR_ERROR = 'CREATE_VENDOR_ERROR';

export const UPDATE_VENDOR_REQUEST = 'UPDATE_VENDOR_REQUEST';
export const UPDATE_VENDOR_SUCCESS = 'UPDATE_VENDOR_SUCCESS';
export const UPDATE_VENDOR_ERROR = 'UPDATE_VENDOR_ERROR';

export const DELETE_VENDOR_REQUEST = 'DELETE_VENDOR_REQUEST';
export const DELETE_VENDOR_SUCCESS = 'DELETE_VENDOR_SUCCESS';
export const DELETE_VENDOR_ERROR = 'DELETE_VENDOR_ERROR';

// POWERFAIDS
export const SAVE_POWERFAIDS_CONFIG_REQUEST = 'SAVE_POWERFAIDS_CONFIG_REQUEST';
export const SAVE_POWERFAIDS_CONFIG_SUCCESS = 'SAVE_POWERFAIDS_CONFIG_SUCCESS';
export const SAVE_POWERFAIDS_CONFIG_ERROR = 'SAVE_POWERFAIDS_CONFIG_ERROR';

export const GET_POE_TOKEN_OPTIONS_REQUEST = 'GET_POE_TOKEN_OPTIONS_REQUEST';
export const GET_POE_TOKEN_OPTIONS_SUCCESS = 'GET_POE_TOKEN_OPTIONS_SUCCESS';
export const GET_POE_TOKEN_OPTIONS_ERROR = 'GET_POE_TOKEN_OPTIONS_ERROR';

export const GET_POWERFAIDS_CONFIG_REQUEST = 'GET_POWERFAIDS_CONFIG_REQUEST';
export const GET_POWERFAIDS_CONFIG_SUCCESS = 'GET_POWERFAIDS_CONFIG_SUCCESS';
export const GET_POWERFAIDS_CONFIG_ERROR = 'GET_POWERFAIDS_CONFIG_ERROR';

export const GET_POWERFAIDS_CONFIG_SELECT_ITEMS_REQUEST = 'GET_POWERFAIDS_CONFIG_SELECT_ITEMS_REQUEST';
export const GET_POWERFAIDS_CONFIG_SELECT_ITEMS_SUCCESS = 'GET_POWERFAIDS_CONFIG_SELECT_ITEMS_SUCCESS';
export const GET_POWERFAIDS_CONFIG_SELECT_ITEMS_ERROR = 'GET_POWERFAIDS_CONFIG_SELECT_ITEMS_ERROR';

export const UPDATE_POWERFAIDS_CONFIG_REQUEST = 'UPDATE_POWERFAIDS_CONFIG_REQUEST';
export const UPDATE_POWERFAIDS_CONFIG_SUCCESS = 'UPDATE_POWERFAIDS_CONFIG_SUCCESS';
export const UPDATE_POWERFAIDS_CONFIG_ERROR = 'UPDATE_POWERFAIDS_CONFIG_ERROR';

// Connector Error Logs
export const GET_CONNECTOR_ERRORS_REQUEST = 'GET_CONNECTOR_ERRORS_REQUEST';
export const GET_CONNECTOR_ERRORS_SUCCESS = 'GET_CONNECTOR_ERRORS_SUCCESS';
export const GET_CONNECTOR_ERRORS_FAILURE = 'GET_CONNECTOR_ERRORS_FAILURE';
export const LOAD_MORE_CONNECTOR_ERRORS_SUCCESS = 'LOAD_MORE_CONNECTOR_ERRORS_SUCCESS';
export const RETRY_ERROR_REQUEST = 'RETRY_ERROR_REQUEST';
export const RETRY_ERROR_SUCCESS = 'RETRY_ERROR_SUCCESS';
export const RETRY_ERROR_FAILURE = 'RETRY_ERROR_FAILURE';
export const REMOVE_DUPLICATE_ERRORS_REQUEST = 'REMOVE_DUPLICATE_ERRORS_REQUEST';
export const REMOVE_DUPLICATE_ERRORS_SUCCESS = 'REMOVE_DUPLICATE_ERRORS_SUCCESS';
export const REMOVE_DUPLICATE_ERRORS_FAILURE = 'REMOVE_DUPLICATE_ERRORS_FAILURE';

// Vendor Credentials
export const GET_VENDOR_CREDENTIALS_REQUEST = 'GET_VENDOR_CREDENTIALS_REQUEST';
export const GET_VENDOR_CREDENTIALS_SUCCESS = 'GET_VENDOR_CREDENTIALS_SUCCESS';
export const GET_VENDOR_CREDENTIALS_ERROR = 'GET_VENDOR_CREDENTIALS_ERROR';

// PowerFAIDS File Drop Key
export const GET_FILEDROP_KEY_REQUEST = 'GET_FILEDROP_KEY_REQUEST';
export const GET_FILEDROP_KEY_SUCCESS = 'GET_FILEDROP_KEY_SUCCESS';
export const GET_FILEDROP_KEY_ERROR = 'GET_FILEDROP_KEY_ERROR';
export const CREATE_FILEDROP_KEY_REQUEST = 'CREATE_FILEDROP_KEY_REQUEST';
export const CREATE_FILEDROP_KEY_SUCCESS = 'CREATE_FILEDROP_KEY_SUCCESS';
export const CREATE_FILEDROP_KEY_ERROR = 'CREATE_FILEDROP_KEY_ERROR';
export const REVOKE_FILEDROP_KEY_REQUEST = 'REVOKE_FILEDROP_KEY_REQUEST';
export const REVOKE_FILEDROP_KEY_SUCCESS = 'REVOKE_FILEDROP_KEY_SUCCESS';
export const REVOKE_FILEDROP_KEY_ERROR = 'REVOKE_FILEDROP_KEY_ERROR';
export const CLEAR_REVEALED_FILEDROP_KEY = 'CLEAR_REVEALED_FILEDROP_KEY';
